import { GuidString } from "./types"


const customProductKeyPrefix = 'H/'

export type CropProtectionProductKey =
    | `F/${number}`
    | `NF/${number}`

export type FertiliserProductKey =
    | `FE/${number}`

export type ManureProductKey =
    | `MA/${number}`

export type SeedProductKey =
    | `CV/${number}`

export type CustomProductKey =
    `${typeof customProductKeyPrefix}${GuidString}`

export type ProductKey =
    | SeedProductKey
    | CropProtectionProductKey
    | FertiliserProductKey
    | ManureProductKey
    | CustomProductKey

export function isCustomProductKey(key: ProductKey) {
    return key && key.startsWith(customProductKeyPrefix)
}

export function customProductKeyToGuid(productKey: ProductKey): GuidString {
    return productKey?.startsWith(customProductKeyPrefix)
        ? productKey.substring(customProductKeyPrefix.length) as GuidString
        : undefined
}

export function guidToCustomProductKey(guid: GuidString): CustomProductKey {
    return `${customProductKeyPrefix}${guid}`
}
